import { Component, OnInit, TemplateRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { Location } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
declare let ga: Function;
import { AppService } from 'src/app/core/services/app.service';
import { ReportComponent } from '../../general/report/report.component';
import { Memo } from '../video-detail-v2/video-detail-memo';
import { videoDetailThemeKey, videoDetailThemeVars } from '../video-detail-v2/video-detail-theme';
import { libraryCountLabel, libraryCover, libraryInitial } from '../playlist/library-card';

@Component({
  selector: 'app-playlist-details',
  templateUrl: './playlist-details.component.html',
  styleUrls: ['./playlist-details.component.scss']
})
export class PlaylistDetailsComponent implements OnInit {
  assets_url = environment.assets_url;
  displayedColumns: string[] = ['Play', 'Album', 'Mintues'];
  dataSource = new MatTableDataSource();

  displayedColumnsVideo: string[] = ['Thumbnail', 'Play', 'Album', 'Mintues'];
  dataSourceVideo = new MatTableDataSource();
  // New-design page (same look as My Library and the new video pages).
  readonly cover = libraryCover;
  readonly countLabel = libraryCountLabel;
  readonly initial = libraryInitial;
  private readonly themeMemo = new Memo<Record<string, string>>();
  get themeVars(): Record<string, string> {
    return this.themeMemo.get(videoDetailThemeKey(this.settingsData), () => videoDetailThemeVars(this.settingsData));
  }

  userInfo: any = {};
  userInfoSubscription: Subscription;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  streamInfo: any = {};
  subEvents: any = [];
  channelName: any;
  modalRef: BsModalRef;
  video_banner_image: string;
  routerevents: Subscription;
  currentPlayerDataSubscription: Subscription;
  musicPlayerData: any;
  currentAudio: any = {};
  currentVideo: any = {};
  currentAudioTime = 0;
  currentVideoTime = 0;
  mediaPlayerDataSubscription: Subscription;

  constructor(
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private location: Location,
    private toastr: ToastrService,
    private appService: AppService
  ) {

    this.routerevents = router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        if (this.isPlayVideo) {
          this.modalRef.hide()
          this.router.navigate[(this.router.url)];
        }
      }
      if (val instanceof NavigationEnd) {
        try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
      }
    })

    this.appService.currentPlayingAudio.subscribe(
      (audio) => {
        this.currentAudio = audio;
      }
    )
    this.appService.currentPlayingVideo.subscribe(
      (video) => {
        this.currentVideo = video;
      }
    )
    this.appService.currentPlayingAudioTime.subscribe(
      (time) => {
        this.currentAudioTime = time;
      }
    )
    this.appService.currentPlayingVideoTime.subscribe(
      (time) => {
        this.currentVideoTime = time;
      }
    )
  }

  ngOnInit() {
    this.musicPlayerData = this.commonSubscribeService.musicPlayerData;
    // this.currentPlayerDataSubscription = this.commonSubscribeService.getCurrentMusicData().subscribe(response => {
    //   if(response){
    //     this.currentPlayer(response);
    //   }
    // });
    this.video_banner_image = this.assets_url + "album-video.png";
    this.channelName = this.router.url.split("/")[1];
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    });
    this.getUserPlaylist();
    this.mediaPlayerDataSubscription = this.commonSubscribeService.getMediaPlayerData().subscribe(response => {
      if (response.key == "musicList") {
        if (response.value.length > 0) {
          console.log(response.value, "playlistarr")
          response.value.forEach((e, i) => {
            let newi = e.playing;
            // console.log(e.playing, newi, newi != 'undefined', "datashow")
            if (typeof e.playing === "undefined") {
            }
            else {
              console.log(e.streamid, "streamid", e.playing, "playlistarr1")
              if (this.playListFirst && this.playListFirst.stream_files && this.playListFirst.stream_files.length > 0) {
                this.playListFirst.stream_files.forEach(el => {
                  console.log(el.streamid, "streamid", e.playing, "playlistarr2")
                  if (e.streamid == el.streamid) {
                    el.isAudioPlaying = e.playing;
                  }

                })
              }
            }
            // if(e.)
          })
        }
        // this.dataSource.data = response.value;
        // this.getUserPlaylist();
      }
    });

  }

  playListAry: any = [];
  playListFirst: any = {};
  playlist_type: string = '';
  songsCount = 0;
  getUserPlaylist() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "playlist_id": this.activatedRoute.snapshot.params.id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_PLAYLIST, data).then(response => {
      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        if (response['data']['Data'] && response['data']['Data'].length > 0) {
          this.playListAry = [];
          this.playListAry = response.data['Data'];
          this.playListFirst = this.playListAry[0];
          this.playlist_type = this.playListFirst.playlist_type;
          this.songsCount = this.playListFirst.stream_files && this.playListFirst.stream_files.length > 0 ? this.playListFirst.stream_files.length : 0;
          this.playListFirst.stream_files = this.playListFirst.stream_files ? this.playListFirst.stream_files.sort((a, b) => a.metadata && a.metadata.track_number && a.metadata.track_number < b.metadata.track_number ? -1 : 1) : [];

          this.playListFirst.stream_files.forEach(ele => {
            if (ele.stream_info.duration) {
              ele.stream_info.duration = this.secondsToTime(ele.stream_info.duration);
            }

            ele.stream_info.ageInfo = 'Family Friendly';
            if (Number(ele.stream_info.age_limit) <= 15) {
              ele.stream_info.ageInfo = 'Family Friendly';
            } else if (Number(ele.stream_info.age_limit) == 16 || Number(ele.stream_info.age_limit) <= 17) {
              ele.stream_info.ageInfo = 'Adults Supervision';
            } else if (Number(ele.stream_info.age_limit) == 18 || Number(ele.stream_info.age_limit) <= 20) {
              ele.stream_info.ageInfo = '18+';
            } else if (Number(ele.stream_info.age_limit) == 21 || Number(ele.stream_info.age_limit) > 21) {
              ele.stream_info.ageInfo = '21+';
            }
          });

          if (this.playlist_type == "audio") {
            this.dataSource.data = this.playListFirst.stream_files || [];
            if (this.musicPlayerData) {
              this.currentPlayer(this.musicPlayerData);
            }
            this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.playListFirst.stream_files });
            this.commonSubscribeService.sendMediaPlayerData({ key: "is_show_musicPlayer", value: true });
          } else if (this.playlist_type == "video") {
            this.dataSourceVideo.data = this.playListFirst.stream_files || [];
            this.commonSubscribeService.sendMediaPlayerData({ key: "is_show_musicPlayer", value: false });
          }
        }
      }
      let musicListresponse = this.commonSubscribeService.mediaPlayerData.musicList
      if (musicListresponse) {
        console.log(musicListresponse, "musicListresponse")
        musicListresponse.forEach(e => {
          this.playListFirst.stream_files.forEach(el => {
            console.log(el.streamid, "streamid", el.playing, "musicListresponse")
            if (typeof e.playing === "undefined") {
            }
            else {
              console.log(e.streamid, "streamid", e.playing, "playlistarr1")
              if (this.playListFirst && this.playListFirst.stream_files && this.playListFirst.stream_files.length > 0) {
                this.playListFirst.stream_files.forEach(el => {
                  console.log(el.streamid, "streamid", e.playing, "playlistarr2")
                  if (e.streamid == el.streamid) {
                    el.isAudioPlaying = e.playing;
                  }

                })
              }
            }

          })
          // if(e.)
        })
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  enablePlay: boolean = false;
  currentPlayer(data, from?) {
    this.playListFirst.stream_files.forEach(element => {
      if (element.streamid == data.streamid && !from) {
        element.isAudioPlaying = true;
      } else {
        element.isAudioPlaying = false;
      }
    });
    this.dataSource.data = this.playListFirst.stream_files;
    let checkAudioPlay = this.playListFirst.stream_files.filter(a => a.isAudioPlaying);
    this.enablePlay = checkAudioPlay.length >= 1 ? true : false;
  }

  getCurrentTime(e) {
    if (e && e.target && e.target.currentTime) {
      this.appService.currentPlayingVideoTime.next(Math.floor(e.target.currentTime))
    }
  }

  reportFileData(data, type) {
    if (type == 'audio') {
      if (this.currentAudio && this.currentAudio.streamid == data.streamid) {
        this.appService.reportData.next({ data: data, type: type, time: this.currentAudioTime })
      }
      else {
        this.appService.reportData.next({ data: data, type: type, time: 0 })
      }
    }
    if (type == 'uploadedVideo' || type == 'recordedVideo' || type == 'playerVideo') {
      if (this.currentVideo && this.currentVideo.streamid == data.streamid) {
        this.appService.reportData.next({ data: data, type: type, time: this.currentVideoTime })
      }
      else {
        this.appService.reportData.next({ data: data, type: type, time: 0 })
      }
    }
    // console.log("CURRENT AUDIO:",this.currentAudio);
    // console.log("CURRENT VIDEO:",this.currentVideo);
    //'uploadedVideo'
    //'recordedVideo'
    //'videoPlayer'
    const dialogRef = this.dialog.open(ReportComponent, {
      panelClass: 'app-report',
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.subEvents.forEach((element, index) => {
          this.subEvents[index]['openMenu']  = false;
        });
      }
      
    });

  }

  savedageans = 15;
  agedata: any;
  video_audio: string = "";
  toggleAudio(data, index, from?) {
    this.agedata = data.stream_info.age_limit;
    this.video_audio = data.vod_video_audio;
    if (this.userInfo.access_token) {
      this.checkAge((status) => {
        if (from == 'pause') {
          data.playing = true;
        }
        this.currentPlayer(data, from);
        if (status == 'yes') {
          this.savedageans = Number(this.agedata) > this.savedageans ? Number(this.agedata) : this.savedageans;
          this.commonSubscribeService.sendMediaPlayerData({ type: "function", key: "toggleAudio", value: { selected_music: data, index: index } });
        } else {
          // this.toastr.info('Age must be above ')
          if (status == 'yes') {
            this.commonSubscribeService.sendMediaPlayerData({ type: "function", key: "toggleAudio", value: { selected_music: data, index: index + 1 } });
          }
        }
      });
    } else {
      //this.requireLogin();
    }
  }

  checkAge(callback) {
    let age_limit = parseInt(this.agedata);
    let status = 'confirm';
    if (!isNaN(age_limit)) {
      if (age_limit <= 15) {
        status = 'yes';
      } else if (age_limit <= this.savedageans) {
        status = 'yes'
      } else if (this.userInfo && this.userInfo.date_of_birth) {
        let age = new Date().getFullYear() - new Date(this.userInfo.date_of_birth).getFullYear();
        if (age_limit <= age) {
          status = 'yes';
        }
        else if (age_limit <= this.savedageans) {
          status = 'yes'
        }
        else {
          status = 'confirm'
        }
      }
    }
    else {
      status = 'yes';
    }
    if (status == 'confirm') {
      let msg = this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status == 'completed' ? 'vod' : 'event';
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'app-signout-confirmation',
        disableClose: true,
        data: { title: "This " + this.video_audio + " is intended for persons of " + age_limit + " years or older. I agree that my age is " + age_limit + " or above." }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result === 'yes') this.commonSubscribeService.saveDateOfBirth(age_limit, this.streamInfo.organization_id);
        callback(result);
      });
    } else {
      callback(status);
    }
  }
  videoURL = "";
  selectedVideo: any = {};
  isPlayVideo: boolean = false;
  selectedStreamInfo: any;
  openModalWithClass(template: TemplateRef<any>, data) {
    console.log(data)
    this.selectedStreamInfo = data;
    this.agedata = data.age_limit;
    this.video_audio = data.vod_video_audio
    if (this.userInfo.access_token) {
      this.checkAge((status) => {
        if (status == 'yes') {
          this.savedageans = Number(this.agedata)
          let vod_data = data.vod_urls ? JSON.parse(data.vod_urls) : {};
          this.videoURL = vod_data.master || "";
          if (data.stream_vod == 'stream') {
            let isVodUrl = false;
            Object.keys(vod_data).forEach(element => {
              if (vod_data[element].includes('vod.m3u8') && !isVodUrl) {
                this.videoURL = vod_data[element] || "";
                isVodUrl = true;
              }
              if (vod_data[element].includes('.m3u8') && !isVodUrl) {
                this.videoURL = vod_data[element] || "";
                isVodUrl = true;
              }
            });
          }
          this.selectedVideo = data;
          this.isPlayVideo = true;
          this.modalRef = this.modalService.show(
            template,
            Object.assign({ keyboard: false }, { class: 'gray modal-lg modal-fullscreen' })
          );
        } else {

        }
      });
    }
  }
  goToPlaylist() {
    // this.commonSubscribeService.sendMediaPlayerData({ key: "is_show_musicPlayer", value: false });
    this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/my-library"]);
  }
  secondsToTime(e) {
    var h = Math.floor(e / 3600).toString().padStart(2, '0'),
      m = Math.floor(e % 3600 / 60).toString().padStart(2, '0'),
      s = Math.floor(e % 60).toString().padStart(2, '0');
    if (h == "00")
      return m + ':' + s;
    else
      return h + ':' + m + ':' + s;
  }
  playFromBanner(template?) {
    if (this.userInfo.access_token) {
      let isFoundPlayMusic = false;
      for (let i = 0; i < this.playListFirst.stream_files.length; i++) {
        const element = this.playListFirst.stream_files[i];
        if (this.playlist_type == 'audio') {
          this.toggleAudio(element, i);
        } else {
          this.openModalWithClass(template, element.stream_info)
        }
        isFoundPlayMusic = true;
        break;
      }

    }
  }
  close() {
    this.modalRef.hide();
  }
  removeFromPlaylist(playlist) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '370px',
      panelClass: 'app-confirmation-dialog',
      data: {
        title: `Are you sure you want to delete ${this.playlist_type}?`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        let data = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": environment.AWS_Cognito.X_Api_Key,
            "Authorization": `Bearer ${this.userInfo.access_token}`
          },
          response: true,
          body: {
            "id": this.playListFirst.id,
            "stream_id": playlist.streamid
          }
        }
        this.ngxLoader.start();
        AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.DELETE_USER_PLAYLIST, data).then(response => {
          this.ngxLoader.stop();
          if (response.data.statusCode === '200') {
            this.toastr.success('Deleted from playlist successfully');
            this.getUserPlaylist();
          }
        }).catch(error => {
          this.ngxLoader.stop();
        });
      }
    });
  }
  ngOnDestroy() {
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.routerevents) {
      this.routerevents.unsubscribe();
    }
  }

}
